import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { map } from 'rxjs/operators';
import { ThemeService } from '../../../@prep/services/theme.service';
import { Router } from '@angular/router';
import { DashboardService } from '../../pages/dashboard/service/dashboard.service';
// Freshwork Service for Help widget Open / Close
import { NgxFreshworkWidgetService } from '../../widget/ngx-freshwork-widget/ngx-freshwork-widget.service';
import { MatSnackBar } from '@angular/material/snack-bar';

import { PlatformGlobalService } from '../service/platform-global.service';
import { Subscription } from 'rxjs';
import { CurrentUserService } from '../../pages/authentication/service/current-user.service';
import { GlobalUser } from '../model/global-user';


import { LanguageSelectorModel } from 'src/@prep/shared/language-selector/model/language-selector.model';
import { LanguageSelectorService } from 'src/@prep/shared/language-selector/service/language-selector.service';
import { TopToolbarTextDataEN } from './toolbar-multi-lang/en-US';
import { TopToolbarTextDataES } from './toolbar-multi-lang/es-EU';
import { TopToolbarTextDataIT } from './toolbar-multi-lang/it-IT';
import { environment } from 'src/environments/environment.prod';


import { MatTooltip } from '@angular/material/tooltip';
import { FocusMonitor } from '@angular/cdk/a11y';

@Component({
  selector: 'prep-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  providers: [DashboardService],
})
export class ToolbarComponent implements OnInit {
  // Global User Account Info
  account: GlobalUser = new GlobalUser();

  // Toolbar Component Header Border
  @Input()
  @HostBinding('class.no-box-shadow')
  hasNavigation: boolean;

  // Mobile Sidenav Navigation 
  @Output() openSidenav = new EventEmitter();

  account_user_name: string; // Full Name of the User
  liccenseExpired = false; // License Expired

  // Prep Tool Enable
  prep_tool_enabled = false;

  // User Roles Enable
  isOrganizationAdmin = false;
  isSuperAdmin = false;
  isDepartmentAdmin = false;


  // Organmization Logo 
  dynamicImgUrl: string = '';
  dynamicimgUrlValid: boolean = false;
  logoAlttext = 'logo';

  // Navigation
  topNavigation$ = this.themeService.config$.pipe(
    map((config) => config.navigation === 'top')
  );

  // Language Selector
  selectedLang: LanguageSelectorModel = this.languageSelectorService.getCurrentLanguage();
  LangTextData: any;

  isApple: boolean = environment.is_apple;
  isOrgAdmin: string = '';
  // Help Desk 
  @ViewChild('helpBtn', { static: false }) helpBtn!: ElementRef<HTMLButtonElement>;
  @ViewChild(MatTooltip, { static: false }) helpBtnTooltip?: MatTooltip;

  constructor(
    private themeService: ThemeService,
    private freeDeskWidgetService: NgxFreshworkWidgetService,
    private dashboardService: DashboardService,
    private snackbar: MatSnackBar,
    private currentUserService: CurrentUserService,
    private platformGlobalService: PlatformGlobalService,
    public router: Router,
    private languageSelectorService: LanguageSelectorService,
    private ngZone: NgZone,
    private focusMonitor: FocusMonitor
  ) {
    this.languageSelectorService.language$.subscribe(lang => {
      this.selectedLang = lang;
      console.log('🌍 Language changed:', lang, lang.code, this.selectedLang.code);
      switch (this.selectedLang.code) {
        case 'en': {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'es': {
          this.LangTextData = TopToolbarTextDataES;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'it': {
          this.LangTextData = TopToolbarTextDataIT;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        default: {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 Default Language:', this.LangTextData);
          break;
        }
      }
    });
  }

  ngOnInit() {
    // Authorize
    this.currentUserService.GetCurrentUser().subscribe(
      (response) => {
        this.platformGlobalService.me = response;
        this.account = response;
        console.log('AccountInfo', this.account, this.account.new_configs.organization.logo)
        if (this.account.new_configs.organization.name) {
          this.logoAlttext = this.account.new_configs.organization.name + ' ' + 'logo';
        }
        if (this.account.new_configs.organization.logo) {
          console.log('AccountInfo Inside', this.account, this.account.new_configs.organization.logo)
          this.dynamicImgUrl = this.account.new_configs.organization.logo;
          this.checkImageUrl(this.dynamicImgUrl);
          console.log(
            'Check logo URL Value',
            this.dynamicImgUrl,
            this.dynamicimgUrlValid
          );
        }
        if (this.account.new_configs.users.enable_manage_accounts === true) {
          this.isOrganizationAdmin = true;
        } else {
          this.isOrganizationAdmin = false;
        }
        if (this.account.new_configs.plan_type === 'rsp') {
          this.prep_tool_enabled = false;
        } else {
          this.prep_tool_enabled = true;

        }
        // For Apple Dashboard
        this.isOrgAdmin = this.account.new_configs.user_access_level_type;
      },
      (error) => {
        console.log('error', error);
      }
    );
    console.log('myinfo', this.platformGlobalService.myUserInfo);
    if (this.platformGlobalService.myUserInfo.username) {
      const accEmail = this.platformGlobalService.myUserInfo.username;
      const accDomain = accEmail.replace(/.*@/, '');
      console.log('Domain Info', accDomain);
    }

    this.account_user_name =
      this.platformGlobalService.myUserInfo.first_name +
      ' ' +
      this.platformGlobalService.myUserInfo.last_name;
    if (this.account.new_configs.license_expired === true) {
      this.liccenseExpired = true;
    }
  }


  checkImageUrl(url: string): void {
    const img = new Image();
    img.onload = () => {
      this.dynamicimgUrlValid = true; // URL is valid
    };
    img.onerror = () => {
      this.dynamicimgUrlValid = false; // URL is invalid
      console.error('Invalid image URL:', url);
    };
    img.src = url; // Trigger the image loading
  }

  clickGoToTraning() {
    console.log(
      'item values',
      this.platformGlobalService.getStoreDashboardInfo
    );
    let videourl: string;
    const urlToken = this.platformGlobalService.getStoreDashboardInfo.url_token;
    if (urlToken !== '') {
      videourl = urlToken;
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', videourl);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      this.snackbar.open(
        'Training video not Available for this user',
        'OK THANKS',
        {
          duration: 10000,
        }
      );
    }
  }

  clickGoTpQuickStartGuide() {
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = 'assets/document/PREP-Quick-Start-Guide.pdf';
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  HelpClickOLd() {
    this.freeDeskWidgetService.FreshworksWidget('hide');
    setTimeout(() => {
      this.freeDeskWidgetService.FreshworksWidget('open');
    }, 500);
  }

  // Call this after fw('hide') or when 'widget:closed' fires
  private focusBackToHelpButton(retries = 20) {
    const el = this.helpBtn?.nativeElement;
    if (!el) return;

    // If the button is hidden at this breakpoint (fxHide/fxShow), wait & retry
    if (!this.isVisibleAndFocusable(el)) {
      if (retries > 0) {
        return setTimeout(() => this.focusBackToHelpButton(retries - 1), 75);
      }
      return; // give up silently
    }

    // Prevent tooltip stealing focus
    try { this.helpBtnTooltip?.hide(0); } catch { }
    // Ensure focusable
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');

    // Use CDK FocusMonitor for keyboard-like focus (announces to SR)
    this.ngZone.runOutsideAngular(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.ngZone.run(() => {
            // If your page scrolls, avoid jumps:
            try { el.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch { }
            this.focusMonitor.focusVia(el, 'keyboard'); // <-- key line
          });
        });
      });
    });
  }

  private isVisibleAndFocusable(el: HTMLElement): boolean {
    // Must be in the document
    if (!document.body.contains(el)) return false;
    const style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    // fxHide often sets display:none; offsetParent null can catch many hidden states
    if (el.offsetParent === null && style.position !== 'fixed') return false;
    // width/height > 0
    const rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    return true;
  }

  HelpClick() {
    const fw = this.freeDeskWidgetService.FreshworksWidget;

    // Avoid duplicate handlers
    try { fw('off', 'widget:closed'); } catch { }

    // Focus return when widget is actually closed (best signal)
    try { fw('on', 'widget:closed', () => this.focusBackToHelpButton()); } catch { }

    fw('hide');
    setTimeout(() => {
      fw('open');

      setTimeout(() => {
        const iframe = document.querySelector<HTMLIFrameElement>('iframe#widget-frame, iframe[id*="freshwidget-"]');
        if (!iframe) return;

        // Land focus inside the widget
        iframe.tabIndex = -1;
        iframe.focus();

        try {
          const doc = iframe.contentDocument || iframe.contentWindow?.document;
          if (!doc) throw new Error();

          const contactBtn =
            doc.querySelector<HTMLElement>('button[data-testid="contact-us"], [data-testid="contact-us"]');
          const closeEl =
            doc.querySelector<HTMLElement>('[data-testid="header-close"], .WidgetHeader__CloseWrapper-e8xmgj-3, [aria-label="Close"], [title="Close"]');
          const sendBtn =
            doc.querySelector<HTMLElement>('#form-button, button[data-testid="form-button"]');

          // Make sure key elements are focusable
          contactBtn?.setAttribute('tabindex', '0');
          closeEl?.setAttribute('tabindex', '0');
          sendBtn?.setAttribute('tabindex', '0');

          // Initial focus target
          (contactBtn || closeEl || sendBtn || doc.body).focus();

          // === Focus trap inside the iframe ==============================
          const getFocusable = () =>
            Array.from(
              doc.querySelectorAll<HTMLElement>(
                [
                  'a[href]',
                  'button:not([disabled])',
                  'input:not([disabled])',
                  'select:not([disabled])',
                  'textarea:not([disabled])',
                  '[tabindex]:not([tabindex="-1"])'
                ].join(',')
              )
            ).filter(el => el.offsetParent !== null || getComputedStyle(el).position === 'fixed');

          const trapKeydown = (e: KeyboardEvent) => {
            if (e.key !== 'Tab') return;
            const focusables = getFocusable();
            if (!focusables.length) return;

            const first = focusables[0];
            const last = focusables[focusables.length - 1];

            // If Shift+Tab on first -> wrap to last
            if (e.shiftKey && doc.activeElement === first) {
              e.preventDefault();
              last.focus();
              return;
            }
            // If Tab on last -> wrap to first
            if (!e.shiftKey && doc.activeElement === last) {
              e.preventDefault();
              first.focus();
              return;
            }
            // Otherwise, allow normal Tab within iframe
          };

          // Attach trap on the iframe doc (capture = true to beat inner handlers)
          doc.addEventListener('keydown', trapKeydown, true);

          // Re-arm trap if widget re-renders internals
          const mo = new MutationObserver(() => {
            // no-op; we’re calling getFocusable() on each Tab press, so the trap stays fresh
          });
          mo.observe(doc.body, { subtree: true, childList: true });

          // === Close & Send: hide and return focus =======================
          const activateAndReturn = (e: Event | KeyboardEvent) => {
            e.preventDefault();
            fw('hide');                       // will trigger widget:closed (if supported)
            setTimeout(() => this.focusBackToHelpButton(), 250); // fallback if no event
          };

          // Close
          closeEl?.addEventListener('click', activateAndReturn as EventListener, { capture: true });
          closeEl?.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Enter' || e.key === ' ') activateAndReturn(e);
          }, { capture: true });

          // Send
          sendBtn?.addEventListener('click', activateAndReturn as EventListener, { capture: true });
          sendBtn?.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Enter' || e.key === ' ') activateAndReturn(e);
          }, { capture: true });

          // Optional: Contact → Tab moves to Close (as you wanted earlier)
          contactBtn?.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Tab' && !e.shiftKey && closeEl) {
              e.preventDefault();
              closeEl.focus();
            }
          }, { capture: true });

        } catch {
          // Cross-origin fallback: can’t trap inside; observe close then focus back
          this.observeCloseThenFocusBack();
        }
      }, 600); // allow inner UI to render
    }, 250);
  }

  private observeCloseThenFocusBack() {
    const start = performance.now();
    const sel = 'iframe#widget-frame, iframe[id*="freshwidget-"]';
    const isClosed = () => {
      const f = document.querySelector<HTMLIFrameElement>(sel);
      if (!f) return true;
      const s = getComputedStyle(f);
      return s.display === 'none' || s.visibility === 'hidden' || s.opacity === '0';
    };
    const poll = () => {
      if (isClosed() || performance.now() - start > 2000) this.focusBackToHelpButton();
      else setTimeout(poll, 50);
    };
    poll();
  }
}
